<ng-container *ngIf="viewModel$ | async as vm">
  <div class="row no-gutters">
    <div class="col p-1">
      <div class="row no-gutters justify-content-center">
        <div class="col-6">
          <fieldset *ngIf="vm.numpad?.visible" [disabled]="!vm.numpad?.enabled">
            <div class="row no-gutters justify-content-center">
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(1)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>1</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(2)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>2</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(3)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>3</small>
                </button>
              </div>
            </div>
            <div class="row no-gutters justify-content-center">
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(4)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>4</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(5)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>5</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(6)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>6</small>
                </button>
              </div>
            </div>
            <div class="row no-gutters justify-content-center">
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(7)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>7</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(8)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>8</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(9)"
                  [disabled]="!vm.numpad?.enabled">
                  <small>9</small>
                </button>
              </div>
            </div>
            <div class="row no-gutters justify-content-center">
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press('*')">
                  <small><i class="fas fa-asterisk"></i></small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press(0)">
                  <small>0</small>
                </button>
              </div>
              <div class="col-4 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" (click)="press('#')">
                  <small><i class="fas fa-hashtag"></i></small>
                </button>
              </div>
            </div>
            <div class="row no-gutters justify-content-center" *ngIf="vm.phoneNumber?.visible">
              <div class="col p-1">
                <form [formGroup]="formGroup">
                  <input *ngIf="!vm.dtmfMode" class="form-control form-control-sm" type="text"
                    formControlName="phoneNumber" title="phone number to dial" (keydown)="dialKeyDown($event)" />
                  <input *ngIf="vm.dtmfMode" class="form-control form-control-sm" type="text"
                    formControlName="dtmfTones" title="dtmf tones to send" (input)="dtmfInput($event)" />
                </form>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-6">
          <div class="row no-gutters justify-content-center" *ngIf="vm.answer?.visible || vm.hangUp?.visible">
            <div class="col-10 p-1">
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.answer?.visible"
                [disabled]="!vm.answer?.enabled" (click)="answer()" title="{{ vm.answer?.hoverText }}">
                <small>Answer</small>
              </button>
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.hangUp?.visible"
                [disabled]="!vm.hangUp?.enabled" (click)="hangUp()" title="{{ vm.hangUp?.hoverText }}">
                <small>Hang Up</small>
              </button>
            </div>
          </div>
          <div class="row no-gutters justify-content-center" *ngIf="vm.hold?.visible || vm.unhold?.visible">
            <div class="col-10 p-1">
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.hold?.visible"
                [disabled]="!vm.hold?.enabled" (click)="hold()" title="{{ vm.hold?.hoverText }}">
                <small>Hold</small>
              </button>
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.unhold?.visible"
                [disabled]="!vm.unhold?.enabled" (click)="unhold()" title="{{ vm.unhold?.hoverText }}">
                <small>Unhold</small>
              </button>
            </div>
          </div>
          <div class="row no-gutters justify-content-center" *ngIf="
              vm.transfer?.visible || vm.cancel?.visible || vm.speedDial?.visible
            ">
            <div class="col-10 p-1">
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.transfer?.visible"
                [disabled]="!vm.transfer?.enabled" (click)="transfer()" title="{{ vm.transfer?.hoverText }}">
                <small>Transfer</small>
              </button>
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.speedDial?.visible"
                [disabled]="!vm.speedDial?.enabled" (click)="speedDial()" title="{{ vm.speedDial?.hoverText }}">
                <small>Speed Dial</small>
              </button>
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.cancel?.visible"
                [disabled]="!vm.cancel?.enabled" (click)="cancel()" title="{{ vm.cancel?.hoverText }}">
                <small>Cancel</small>
              </button>
            </div>
          </div>
          <div class="row no-gutters justify-content-center" *ngIf="vm.unavailable?.visible">
            <div class="col-10 p-1">
              <button type="button" class="btn btn-secondary btn-sm btn-block" *ngIf="vm.unavailable?.visible"
                [disabled]="!vm.unavailable?.enabled" (click)="unavailable()" title="{{ vm.unavailable?.hoverText }}">
                <small>Unavailable</small>
              </button>
            </div>
          </div>
          <ng-container *libHasClaim="Unity4Claim.DialButton">
            <div class="row no-gutters justify-content-center" *ngIf="vm.dial?.visible">
              <div class="col-10 p-1">
                <button type="button" class="btn btn-secondary btn-sm btn-block" [disabled]="!vm.dial?.enabled"
                  (click)="dial()" title="{{ vm.dial?.hoverText }}">
                  <small>Dial</small>
                </button>
              </div>
            </div>
          </ng-container>
          <div class="row no-gutters justify-content-center">
            <div class="col-10 p-1">
              <small style="font-size: 8px" [ngClass]="{ 'text-danger': vm.sipStatus?.error }">{{
                vm.sipStatus?.msg }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>